module.exports = __webpack_public_path__ + "static/web-image-embedding-c2e03dc6bac57ea2e1fc3ea0deb4deae.gif";